import Types from "./Types";

export const studentsPerGroupRequest = (id) => ({
  type: Types.STUDENTS_PER_GROUP_REQUEST,
  payload: id,
});

export const studentsPerGroupSuccess = (id) => ({
  type: Types.STUDENTS_PER_GROUP_SUCCESS,
  payload: id,
});

export const studentsPerGroupFail = () => ({
  type: Types.STUDENTS_PER_GROUP_FAIL,
});

export const videoReportRequest = (id) => ({
  type: Types.VIDEO_REPORT_REQUEST,
  payload: id,
});

export const videoReportSuccess = (id) => ({
  type: Types.VIDEO_REPORT_SUCCESS,
  payload: id,
});

export const videoReportFail = () => ({
  type: Types.VIDEO_REPORT_FAIL,
});

export const attendanceReportRequest = (lecId, date) => ({
  type: Types.ATTENDANCE_REPORT_REQUEST,
  lecId: lecId,
  date: date,
});

export const attendanceReportSuccess = (id) => ({
  type: Types.ATTENDANCE_REPORT_SUCCESS,
  payload: id,
});

export const attendanceReportFail = () => ({
  type: Types.ATTENDANCE_REPORT_FAIL,
});

export const examReportRequest = (id) => ({
  type: Types.EXAM_REPORT_REQUEST,
  payload: id,
});

export const examReportSuccess = (id) => ({
  type: Types.EXAM_REPORT_SUCCESS,
  payload: id,
});

export const examReportFail = () => ({
  type: Types.EXAM_REPORT_FAIL,
});

export const examAttendaceRequest = (id) => ({
  type: Types.EXAM_ATTENDANCE_REQUEST,
  payload: id,
});

export const examAttendaceSuccess = (id) => ({
  type: Types.EXAM_ATTENDANCE_SUCCESS,
  payload: id,
});

export const examAttendaceFail = () => ({
  type: Types.EXAM_ATTENDANCE_FAIL,
});

export const unpaidReportRequest = (groupId,paymentId) => ({
  type: Types.UNPAID_REPORT_REQUEST,
  payload: { groupId, paymentId },
});

export const unpaidReportSuccess = (id) => ({
  type: Types.UNPAID_REPORT_SUCCESS,
  payload: id,
});

export const unpaidReportFail = () => ({
  type: Types.UNPAID_REPORT_FAIL,
});

export const paidReportRequest = (id) => ({
  type: Types.PAID_REPORT_REQUEST,
  payload: id,
});

export const paidReportSuccess = (id) => ({
  type: Types.PAID_REPORT_SUCCESS,
  payload: id,
});

export const paidReportFail = () => ({
  type: Types.PAID_REPORT_FAIL,
});
export const reportLoading = (isLoading) => ({
  type: Types.REPORT_LOADING,
  payload: isLoading,
});

export const homeworkAttendenceReportRequest = (id) => ({
  type: Types.HOMEWORK_ATTENDENCE_REPORT_REQUEST,
  payload: id,
});

export const homeworkAttendenceReportSuccess = (id) => ({
  type: Types.HOMEWORK_ATTENDENCE_REPORT_SUCCESS,
  payload: id,
});

export const homeworkAttendenceReportFail = () => ({
  type: Types.HOMEWORK_ATTENDENCE_REPORT_FAIL,
});

export const homeworkUncommentReportRequest = (id) => ({
  type: Types.HOMEWORK_UNCOMMENT_REPORT_REQUEST,
  payload: id,
});

export const homeworkUncommentReportSuccess = (id) => ({
  type: Types.HOMEWORK_UNCOMMENT_REPORT_SUCCESS,
  payload: id,
});

export const homeworkUncommentReportFail = () => ({
  type: Types.HOMEWORK_UNCOMMENT_REPORT_FAIL,
});

export const filterHomeworkAttendenceReportRequest = (id) => ({
  type: Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_REQUEST,
  payload: id,
});

export const filterHomeworkAttendenceReportSuccess = (id) => ({
  type: Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS,
  payload: id,
});

export const filterHomeworkAttendenceReportFail = () => ({
  type: Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_FAIL,
});
export const homeworkAbsentReportRequest = (id) => ({
  type: Types.HOMEWORK_ABSENT_REPORT_REQUEST,
  payload: id,
});

export const homeworkAbsentReportSuccess = (id) => ({
  type: Types.HOMEWORK_ABSENT_REPORT_SUCCESS,
  payload: id,
});

export const homeworkAbsentReportFail = () => ({
  type: Types.HOMEWORK_ABSENT_REPORT_FAIL,
});

//delete student homework

export const deleteStuentHomeworkRequest = (payload) => ({
  type: Types.DELETE_STUDENT_HOMEWORK_REQUEST,
  payload,
});

export const deleteStuentHomeworkSuccess = (data) => ({
  type: Types.DELETE_STUDENT_HOMEWORK_SUCCESS,
  payload: data,
});

export const deleteStuentHomeworkFail = () => ({
  type: Types.DELETE_STUDENT_HOMEWORK_FAIL,
});

//assign stuent homework to restrict group

export const restrictStuentHomeworkRequest = (id) => ({
  type: Types.RESTRICT_STUDENT_HOMEWORK_REQUEST,
  payload: id,
});

export const restrictStuentHomeworkSuccess = (id) => ({
  type: Types.RESTRICT_STUDENT_HOMEWORK_SUCCESS,
  payload: id,
});

export const restrictStuentHomeworkFail = () => ({
  type: Types.RESTRICT_STUDENT_HOMEWORK_FAIL,
});

export const acceptStuentHomeworkRequest = (id) => ({
  type: Types.ACCEPT_STUDENT_HOMEWORK_REQUEST,
  payload: id,
});

export const acceptStuentHomeworkSuccess = (id) => ({
  type: Types.ACCEPT_STUDENT_HOMEWORK_SUCCESS,
  payload: id,
});

export const acceptStuentHomeworkFail = () => ({
  type: Types.ACCEPT_STUDENT_HOMEWORK_FAIL,
});

export const commentStuentHomeworkRequest = (payload) => ({
  type: Types.COMMENT_STUDENT_HOMEWORK_REQUEST,
  payload,
});

export const commentStuentHomeworkSuccess = (id) => ({
  type: Types.COMMENT_STUDENT_HOMEWORK_SUCCESS,
  payload: id,
});

export const commentStuentHomeworkFail = () => ({
  type: Types.COMMENT_STUDENT_HOMEWORK_FAIL,
});

export const studentPerformanceRequest = (payload) => ({
  type: Types.STUDENT_PERFORMANCE_REQUEST,
  payload,
});

export const studentPerformanceSuccess = (id) => ({
  type: Types.STUDENT_PERFORMANCE_SUCCESS,
  payload: id,
});

export const studentPerformanceFail = () => ({
  type: Types.STUDENT_PERFORMANCE_FAIL,
});

export const monthlyReportRequest = (payload) => ({
  type: Types.MONTHLY_REPORT_REQUEST,
  payload,
});

export const monthlyReportSuccess = (data) => ({
  type: Types.MONTHLY_REPORT_SUCCESS,
  payload: data,
});

export const monthlyReportFail = () => ({
  type: Types.MONTHLY_REPORT_FAIL,
});

export const sendBulkCustomMessageRequest = (payload) => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_REQUEST,
  payload,
});

export const sendBulkCustomMessageSuccess = (data) => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_SUCCESS,
  payload: data,
});

export const sendBulkCustomMessageFail = () => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_FAIL,
});

export const centerHwRequest = (payload) => ({
  type: Types.CENTER_HW_REQUEST,
  payload,
});

export const centerHwSuccess = (id) => ({
  type: Types.CENTER_HW_SUCCESS,
  payload: id,
});

export const centerHwFail = () => ({
  type: Types.CENTER_HW_FAIL,
});

export const videoAbsenceReportRequest = (payload) => ({
  type: Types.VIDEO_ABSENCE_REPORT_REQUEST,
  payload,
});

export const videoAbsenceReportSuccess = (id) => ({
  type: Types.VIDEO_ABSENCE_REPORT_SUCCESS,
  payload: id,
});

export const videoAbsenceReportFail = () => ({
  type: Types.VIDEO_ABSENCE_REPORT_FAIL,
});

export const getSavedMessagesByIntervalRequest = (payload) => ({
  type: Types.GET_SAVED_MESSAGES_BY_INTERVAL_REQUEST,
  payload,
});

export const getSavedMessagesByIntervalSuccess = (data) => ({
  type: Types.GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS,
  payload: data,
});

export const getSavedMessagesByIntervalFail = () => ({
  type: Types.GET_SAVED_MESSAGES_BY_INTERVAL_FAIL,
});

export const sendSavedMessagesRequest = (payload) => ({
  type: Types.SEND_SAVED_MESSAGES_REQUEST,
  payload,
});

export const sendSavedMessagesSuccess = (data) => ({
  type: Types.SEND_SAVED_MESSAGES_SUCCESS,
  payload: data,
});

export const sendSavedMessagesFail = () => ({
  type: Types.SEND_SAVED_MESSAGES_FAIL,
});

export const notifyParentForExamAbsenceRequest = (payload) => ({
  type: Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_REQUEST,
  payload,
});

export const notifyParentForExamAbsenceSuccess = (data) => ({
  type: Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS,
  payload: data,
});

export const notifyParentForExamAbsenceFail = () => ({
  type: Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL,
});

export const getMessagesByReceiverPhoneRequest = (payload) => ({
  type: Types.GET_MESSAGES_BY_RECEIVER_PHONE_REQUEST,
  payload,
});

export const getMessagesByReceiverPhoneSuccess = (data) => ({
  type: Types.GET_MESSAGES_BY_RECEIVER_PHONE_SUCCESS,
  payload: data,
});

export const getMessagesByReceiverPhoneFail = () => ({
  type: Types.GET_MESSAGES_BY_RECEIVER_PHONE_FAIL,
});

export const getManualExamMarksRequest = (payload) => ({
  type: Types.GET_MANUAL_EXAM_MARKS_REQUEST,
  payload,
});

export const getManualExamMarksSuccess = (data) => ({
  type: Types.GET_MANUAL_EXAM_MARKS_SUCCESS,
  payload: data,
});

export const getManualExamMarksFail = () => ({
  type: Types.GET_MANUAL_EXAM_MARKS_FAIL,
});

export const addStudentNoteRequest = (payload) => ({
  type: Types.ADD_STUDENT_NOTE_REQUEST,
  payload,
});

export const addStudentNoteSuccess = (data) => ({
  type: Types.ADD_STUDENT_NOTE_SUCCESS,
  payload: data,
});

export const addStudentNoteFail = () => ({
  type: Types.ADD_STUDENT_NOTE_FAIL,
});

export const getTelegramActiveUsersRequest = (payload) => ({
  type: Types.GET_TELEGRAM_ACTIVE_USERS_REQUEST,
  payload,
});

export const getTelegramActiveUsersSuccess = (data) => ({
  type: Types.GET_TELEGRAM_ACTIVE_USERS_SUCCESS,
  payload: data,
});

export const getTelegramActiveUsersFail = () => ({
  type: Types.GET_TELEGRAM_ACTIVE_USERS_FAIL,
});

export const getTelegramInactiveUsersRequest = (payload) => ({
  type: Types.GET_TELEGRAM_INACTIVE_USERS_REQUEST,
  payload,
});

export const getTelegramInactiveUsersSuccess = (data) => ({
  type: Types.GET_TELEGRAM_INACTIVE_USERS_SUCCESS,
  payload: data,
});

export const getTelegramInactiveUsersFail = () => ({
  type: Types.GET_TELEGRAM_INACTIVE_USERS_FAIL,
});

export const getAbsentStudentsRequest = (payload) => ({
  type: Types.GET_ABSENT_STUDENTS_REQUEST,
  payload,
});

export const getAbsentStudentsSuccess = (data) => ({
  type: Types.GET_ABSENT_STUDENTS_SUCCESS,
  payload: data,
});

export const getAbsentStudentsFail = () => ({
  type: Types.GET_ABSENT_STUDENTS_FAIL,
});

export const paymentReportRequest = (payload) => ({
  type: Types.PAYMENT_REPORT_REQUEST,
  payload,
});

export const paymentReportSuccess = (data) => ({
  type: Types.PAYMENT_REPORT_SUCCESS,
  payload: data,
});

export const paymentReportFail = () => ({
  type: Types.PAYMENT_REPORT_FAIL,
});

// payload: { paid: number[], unpaid: number[] } — payment subject id arrays
export const getPaidUnpaidStudentsRequest = (payload) => ({
  type: Types.GET_PAID_UNPAID_STUDENTS_REQUEST,
  payload,
});

export const getPaidUnpaidStudentsSuccess = (data) => ({
  type: Types.GET_PAID_UNPAID_STUDENTS_SUCCESS,
  payload: data,
});

export const getPaidUnpaidStudentsFail = () => ({
  type: Types.GET_PAID_UNPAID_STUDENTS_FAIL,
});

// payload: { payment_subject_ids: number[], video_ids: number[] }
export const getPaidUnviewedVideosRequest = (payload) => ({
  type: Types.GET_PAID_UNVIEWED_VIDEOS_REQUEST,
  payload,
});

export const getPaidUnviewedVideosSuccess = (data) => ({
  type: Types.GET_PAID_UNVIEWED_VIDEOS_SUCCESS,
  payload: data,
});

export const getPaidUnviewedVideosFail = () => ({
  type: Types.GET_PAID_UNVIEWED_VIDEOS_FAIL,
});

// payload: { user_ids: number[], message: string }
export const sendAttendanceCustomMessageRequest = (payload) => ({
  type: Types.SEND_ATTENDANCE_CUSTOM_MESSAGE_REQUEST,
  payload,
});

export const sendAttendanceCustomMessageSuccess = (data) => ({
  type: Types.SEND_ATTENDANCE_CUSTOM_MESSAGE_SUCCESS,
  payload: data,
});

export const sendAttendanceCustomMessageFail = () => ({
  type: Types.SEND_ATTENDANCE_CUSTOM_MESSAGE_FAIL,
});